import { Card, Head } from "@authoxi/ui-shared";
import { TOOLS } from "../tools";
import { Grader } from "./Grader";

const TONE = ["challenge", "allow", "escalate"] as const;

/**
 * The index **is** the grader.
 *
 * Making a visitor click through to the most useful thing on the page is a click spent on
 * navigation rather than on value — and this is the one tool that explains all the others by
 * running. It renders the same component `/grader` does, so the two can never disagree about
 * what a scan looks like.
 */
export function Index() {
  return (
    <>
      <Head
        pill="Free forever"
        title="Useful before you are a customer."
        lede="Eleven tools that need no account, no card and no call. Every one gives you the answer first — the email ask, where there is one, comes after and is a single field."
      />

      <div className="hero-tool" data-testid="hero-tool">
        <div className="hero-tool-in">
          <span className="label" style={{ color: "#fff", opacity: 0.8 }}>
            Start here
          </span>
          <h2 className="lg" style={{ color: "#fff", margin: "var(--s3) 0" }}>
            Can your agent be identified at all?
          </h2>
          <p
            className="sm"
            style={{ color: "#fff", opacity: 0.85, maxWidth: "46ch", margin: "0 0 var(--s5)" }}
          >
            Paste any agent or MCP endpoint. Six checks, a grade, and the exact fix for each
            failure.
          </p>
          <Grader compact />
        </div>
      </div>

      {TOOLS.map((group, gi) => (
        <div key={group.group}>
          <div className="rule" style={{ marginTop: "var(--s7)" }}>
            <span className="label" style={{ color: `var(--${TONE[gi]}-text)` }}>
              {group.group}
            </span>
          </div>
          <div className="tools">
            {group.items
              .filter((t) => t.id !== "grader")
              .map((t) => (
                <a className={`tool-card tc-${TONE[gi]}`} href={`/tools/${t.id}`} key={t.id}>
                  <h3>{t.name}</h3>
                  <p>{t.blurb}</p>
                  <div className="go">Open →</div>
                </a>
              ))}
          </div>
        </div>
      ))}

      <Card pad="lg" className="" >
        <p className="label">Why this is free</p>
        <p style={{ margin: "var(--s3) 0 0", color: "var(--ink-2)", maxWidth: "var(--measure)" }}>
          The blocks are free; the evidence is what we charge for. An access-control product that
          charges for enforcement is charging people to be safe, and they turn it off. Everything
          on this page stays free — and the grader will happily tell you our own endpoints are
          imperfect.
        </p>
      </Card>
    </>
  );
}
